import CrownIcon from 'features/Engagement/EmployeePerformance/CrownIcon'
import GraphIcon from 'features/Engagement/GraphIcon'
import { useEffect, useState } from 'react'
import engagementApi from 'services/api/engagement'

import styles from './EmployeePerformance.module.scss'

const EmployeePerformance = ({
  onOpenDetails,
  startDate,
  endDate,
  hotelIds,
  seeAllHotels
}) => {
  const [agentsData, setAgentsData] = useState()
  const [agentsDataStatus, setAgentsDataStatus] = useState('pending')
  const [agentsDataError, setAgentsDataError] = useState()

  useEffect(() => {
    const abortController = new AbortController()

    if (!seeAllHotels) {
      setAgentsDataStatus('pending')

      engagementApi
        .agents(
          {
            subsidiaryIds: hotelIds,
            fromDate: startDate.format('YYYY-MM-DD'),
            toDate: endDate.format('YYYY-MM-DD')
          },
          abortController
        )
        .then(data => {
          setAgentsData(data)
          setAgentsDataStatus('fetched')
        })
        .catch(err => {
          if (!err.toString().includes('The user aborted a request.')) {
            setAgentsDataStatus('rejected')
            setAgentsDataError(err)
          }
        })
    }

    return () => abortController.abort()
  }, [hotelIds, startDate, endDate, seeAllHotels])

  if (agentsDataStatus === 'pending') {
    return <div className={styles.wrapper}></div>
  }

  if (agentsDataStatus === 'rejected') {
    return (
      <div className={styles.wrapper}>
        Failed to get data: {agentsDataError?.toString()}
      </div>
    )
  }

  if (seeAllHotels) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h3 className={styles.title}>Employees by performance</h3>
        </div>
        <p>This feature is not available for all hotels</p>
      </div>
    )
  }

  const totalMessages = Object.values(agentsData).reduce(
    (prev, curr) => curr.totalMessagesSent + prev,
    0
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className={styles.title}>Employees by performance</h3>
        <button className={styles.detailsLink} onClick={onOpenDetails}>
          <GraphIcon width={24} height={24} style={{ marginRight: 8, marginLeft: -4 }} />
          View change over time
        </button>
      </div>
      <table className={styles.table}>
        <tr>
          <th></th>
          <th>Messages sent</th>
          <th>Resolved threads</th>
          <th>Messages percentage</th>
        </tr>
        {Object.values(agentsData)
          .sort((a, b) => b.totalMessagesSent - a.totalMessagesSent)
          .map((a, i) => (
            <tr key={a.dashboardUserName}>
              <td>
                {i === 0 && <CrownIcon className={styles.crown} />} {a.dashboardUserName}
              </td>
              <td>{a.totalMessagesSent}</td>
              <td>{a.totalChatsClosed}</td>
              <td>{Math.round((100 * a.totalMessagesSent) / totalMessages)}% </td>
            </tr>
          ))}
      </table>
    </div>
  )
}

export default EmployeePerformance
